module.exports = __webpack_public_path__ + "static/media/logo-external-retina.ddb57a5b.png";